import React from 'react'
import './admin-functions.styles.scss'
import { UseCloudAdminFunction } from '../../../utils/firebase.utils'

const AdminFunctions = () => {

  async function runAdminFunction(command, data) {
    console.log(`Running admin function: ${command}`)
    const res = await UseCloudAdminFunction(command, data)
    console.log(res);
  }

  return (
    <div className="admin-functions">
      <div className='g-card functions-content'>
        <h3>Admin Functions</h3>
        <hr />
        <div className='admin-buttons'>
          {/* <button className='g-button' onClick={() => runAdminFunction(
            'moveEvalsToFirestore', 
            {'data': 'some data'}
          )}>
            Move Evaluations to Firestore
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'moveCompletedEvalsToFirestore', 
            {'data': 'some data'}
          )}>
            Move All Completed Evaluations to Firestore
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'moveSelectedEvalsToFirestore', 
            {'cstKey': '60525e48-283c-4ed3-b647-788d5f0aeac8'}
          )}>
            Move Select Completed Evaluations to Firestore
          </button> */}
          <button className='g-button disabled' onClick={() => runAdminFunction(
            'refactorEvaluations',
            {
              
            }
          )}>
            Refactor Evaluations
          </button>
          <button className='g-button ' onClick={() => runAdminFunction(
            'refactorQuestionSets',
            {}
          )}>
            Refactor Question Sets
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'refactorEvalList',
            {}
          )}>
            Refactor Eval List
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminFunctions